import { msg } from "@lingui/core/macro";

export const isNotOnLocationDenyListRuleMessages = {
	name: msg({ message: "Is Not On Location Deny List" }),
	description: msg({
		message:
			"Vehicles must not be on any tenant's deny list at the permit's location, even when the deny-listing tenant is not attached to the permit",
	}),
	errors: {
		vehicleOnDenyList: msg({ message: "Vehicle is on the deny list for this location: {plates}" }),
	},
} as const;
